import { assertNever } from '@kofno/piper';
import { action, makeObservable, observable } from 'mobx';
import { loading, ready, State, unavailable } from './Types';

/**
 * The total shown beside a segment label. One instance per segment, so a
 * failed count hides only that segment's number.
 */
class CountStore {
  @observable
  state: State = loading();

  constructor() {
    makeObservable(this);
  }

  @action
  ready = (total: number) => {
    switch (this.state.kind) {
      case 'loading':
        this.state = ready(total);
        break;
      case 'ready':
      case 'unavailable':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  unavailable = () => {
    switch (this.state.kind) {
      case 'loading':
        this.state = unavailable();
        break;
      case 'ready':
      case 'unavailable':
        break;
      default:
        assertNever(this.state);
    }
  };
}

export default CountStore;
